module.exports = __webpack_public_path__ + "static/media/weekly.cae26261.png";